<template lang="pug">
    .flex.flex-col.w-full
        template(v-if="label")
            label.text-xs.mb-2 {{ label  }}
        .flex.flex-col.w-full
            .flex.flex-col.w-full.mr-10(v-if="filelist.length")
                template(v-for="file in filelist")
                    .flex.w-full.p-2.bg-white.mb-2.border-1
                        .flex.justify-between.w-full
                            .flex.items-center.w-full
                                template(v-if="['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)")
                                    .min-w-50.h-50(
                                        :style="`background-image: url(${onImage({file})}); background-size: cover; background-position: center center;`" 
                                        :class="{'rounded-full': thumb_shape === 'circle'}"
                                    )
                                template(v-else)
                                    img.block.w-5(:src="IMGS.doc_icon")    
                                .flex.flex-col.w-full.ml-5
                                    .text-sm
                                        span {{file.name}}
                                    .text-sm.text-gray-400
                                        span {{formatBytes(file.size)}}
                                    //- .relative.w-full.h-progress-bar.bg-red-100
                                    //-     .app-file-progress.absolute.bg-red-600.h-progress-bar.w-full
                            .flex.mr-1
                                img.cursor-pointer(:src="IMGS.close_icon" @click="onDelete")
            div
                .relative.w-full.border-dashed.border-2.bg-white(
                    @dragover="dragover" 
                    @dragleave="dragleave" 
                    @drop="drop"
                )
                    .p-5.flex.justify-center.items-center.w-full(@click="onFile")
                        .flex.items-center
                            template(v-if="isLoading")
                                loader
                            template(v-else)
                                img.block.cursor-pointer(:src="IMGS.doc_icon" class="768:mb-10")
                                .text-sm.text-black.text-gray-400.ml-10(class="768:ml-0")
                                    //- span(class="hidden 768:block") {{ FORM.grab_files }}
                                    //- span(class="block 768:hidden") {{ FORM.grab_files_mobile }}
                        input(type="file" ref="file_upload" style="display: none;" @input="onFileChange")
                    input(
                        type="file" 
                        name="fields[assetsFieldHandle][]" 
                        id="assetsFieldHandle" 
                        class="w-px h-px opacity-0 overflow-hidden absolute" 
                        @change="onChange" 
                        ref="file" 
                    )

                template(v-if="fileSizeError || fileTypeError")
                        .inline-flex.bg-red-100.p-20.mb-20.w-full
                            .text-sm {{ fileSizeError }}
                            .text-sm {{ fileTypeError }}

                //- .text-xs.text-gray-400(v-html="FORM.files_note")
</template>

<script>
//Components
import LoaderStyleOne from '@/components/common/loaders';
//Store
//Helers
import {formatBytes} from '@/helpers/format-bytes'

export default {
    name: "FileDragAndDrop",
    components: {
        'loader': LoaderStyleOne,
    },
    props: {
        thumb_shape: {
            type: String,
            default: 'circle',
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
        },
    },
    data() {
        return {
            filelist: [],
            fileSizeError: '',
            fileTypeError: '',
            isLoading: false,
        }
    },
    computed: {
        IMGS() {
            return {
                doc_icon: require('./assets/doc.svg'),
                close_icon: require('./assets/close.svg'),
            }
        },
    },
    methods: {
        formatBytes(bytes) {
            return formatBytes(bytes)
        },
        onChange() {
            // this.filelist.push(...this.$refs.file.files);
            this.onLoadFile(this.$refs.file.files)
        },
        remove(i) {
            this.filelist.splice(i, 1);
        },
        dragover(event) {
            event.preventDefault();
            // Add some visual fluff to show the user can drop its files
            if (!event.currentTarget.classList.contains('bg-gray-300')) {
                event.currentTarget.classList.remove('bg-gray-100');
                event.currentTarget.classList.add('bg-gray-300');
            }
        },
        dragleave(event) {
            // Clean up
            event.currentTarget.classList.add('bg-gray-100');
            event.currentTarget.classList.remove('bg-gray-300');
        },
        drop(event) {
            event.preventDefault();
            this.$refs.file.files = event.dataTransfer.files;
            this.onChange(); // Trigger the onChange event manually
            // Clean up
            event.currentTarget.classList.add('bg-gray-100');
            event.currentTarget.classList.remove('bg-gray-300');
        },
        onFile() {
            this.$refs['file_upload'].click()
        },
        onFileChange() {
            // this.filelist.push(...this.$refs['file_upload'].files)
            this.onLoadFile(this.$refs['file_upload'].files)
        },
        onFileSizeValidation(size) {
            if (size > 104857600) {
                this.fileSizeError = 'Размер файла превышает 100MB.'
                return false
            } else {
                return true
            }
        },
        onFileTypeValidation(type) {
            if (['video/mp4', 'image/jpeg', 'image/png', 'image/jpg', 'video/quicktime'].includes(type)) {
                return true
            } else {
                this.fileTypeError = 'Неверный тип файла.'
                return false
            }
        },
        async onLoadFile(files) {
            if (this.onFileTypeValidation(files[0].type) && this.onFileSizeValidation(files[0].size)) {
                if (this.multiple) 
                    this.filelist.push(...files)
                else
                    this.filelist = [...files]
                this.$emit('files', this.filelist)
            }
        },
        onImage({ file }) {
            const path = (window.URL || window.webkitURL).createObjectURL(file)
            return path
        },
        async onDelete(file) {
            this.remove(this.filelist.indexOf(file))
        },
    },
    watch: {
        filelist: {
            handler(val) {
                this.$emit('value', val)
            },
            deep: true,
        }
    }
}
</script>

<style lang="scss">
.app-file-progress {
    border-radius: 500px !important;
    box-shadow: 0px 1px 4px rgba(red, .5);
}
</style>